export default filters => {
    if (!filters) {
        return null;
    }

    return filters
        .filter(e => e)
        .reduce((acc, val) => {
            acc[val.value] = {};
            return acc;
        }, {});
};
